import { useState } from 'react'
import { BottomSheet, Button } from '@healingpaper/cell'

import PassLogo from '@/assets/logos/pass-logo'
import { useNiceVerification } from '@/features/identity-verification/bridge/helpers/hooks/use-nice-verification'

interface Props {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
}

const IdentityVerificationModal = ({ isOpen, onClose, onSuccess }: Props) => {
  const [isVerifying, setIsVerifying] = useState(false)

  const { startVerification } = useNiceVerification({
    onComplete: (success) => {
      setIsVerifying(false)
      if (success) {
        onSuccess()
      } else {
        alert('본인인증에 실패했습니다. 다시 시도해주세요.')
      }
    },
  })

  const handleStartVerification = () => {
    setIsVerifying(true)
    void startVerification()
  }

  return (
    <BottomSheet
      visible={isOpen}
      onClose={onClose}
      buttonStack={
        <div className="px-6 mb-6">
          <Button size="Large" onClick={handleStartVerification} disabled={isVerifying} className="w-full">
            {isVerifying ? '본인 인증 중이에요' : '본인 인증하기'}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center py-5">
        <div className="w-full px-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-3 text-left">본인 인증을 진행할게요</h2>

          <p className="text-sm font-normal text-gray800 text-left leading-5 mb-8">
            본인 인증 정보는 상담 신청을 위해서만 사용되며 외부에 공개되지 않아요
          </p>
        </div>

        <div className="w-[calc(100%-48px)] mx-6 mb-4">
          <div className="p-6 border border-gray300 rounded-2xl bg-white">
            <div className="flex flex-col items-center">
              <PassLogo className="mb-4" />
              <span className="text-base font-semibold text-gray-900 mb-2">전화번호로 본인 인증</span>
              <p className="text-[13px] font-normal text-gray800 text-center leading-[18px]">
                생년월일, 이름, 전화번호로 본인 인증을 진행해요
              </p>
            </div>
          </div>
        </div>
      </div>
    </BottomSheet>
  )
}

export default IdentityVerificationModal
